
import { SEND_NOTIFICATION} from '../lib/constants/api-urls';
import Api from "../lib/api-call";


export class NotificationService {

  static instance;
  static getInstance() {
    if (!NotificationService.instance) {
      NotificationService.instance = new NotificationService();
    }
    return NotificationService.instance;
  }
  sendNotification = async (params) => {
    let newsResponse = await Api.post(`${SEND_NOTIFICATION.URL}`,  params);
    return newsResponse;
  }
  
  
}

